import React from 'react';

import QuestionLabel from './Components/QuestionLabel';
import FileUpload from './Components/FileUpload';
import Link from './Components/Link';

export default function DisplayProperties({ question }) {
  return <>
    <QuestionLabel question={question} label="Instructions" />

    <FileUpload question={question} />

    <Link question={question} />
  </>

}